import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  categoryText: {
    cursor: 'default',
    color: 'var(--text-color)',
    fontStyle: 'italic',
    transition: 'all 0.2s ease-in-out',
    display: 'inline-block',
    position: 'relative',
    '&:not(:last-child)': {
      marginRight: '16px',
    },
    '&:not(:last-child)::after': {
      content: '"|"',
      position: 'absolute',
      fontWeight: 300,
      right: '-10px',
      color: 'var(--text-color)',
      fontStyle: 'normal',
      textDecoration: 'none',
      filter: 'brightness(0.8)',
    },
    '&.clickable': {
      cursor: 'pointer',
      color: '#46c0ec',
      fontWeight: 500,
      textDecoration: 'underline',
      textUnderlineOffset: '2px',
      '&:hover': {
        filter: 'brightness(120%)',
        color: '#46c0ec',
      },
    },
    '&.selected': {
      color: '#46c0ec',
      fontWeight: 700,
    },
    '&.loading': {
      cursor: 'wait',
      opacity: 0.3,
    },
    '&.hidden': {
      display: 'none',
    },
  },
  divider: {
    color: 'var(--text-color)',
  },
}));
